import { render, staticRenderFns } from "./EmployeeDetailsSummaryPage.vue?vue&type=template&id=36520e9b&lang=pug"
import script from "./EmployeeDetailsSummaryPage.vue?vue&type=script&lang=ts"
export * from "./EmployeeDetailsSummaryPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports